import { MediaView } from './MediaView';
import { ParallaxMedia } from './ParallaxMedia';
import type { Media } from '../../core/types/media';
type Props = {
  /** Het beeld, zodra het er is. Zonder beeld: een rustig vlak in precies dezelfde maat. */
  media?: Media | null;
  /** Vorm en maat (bijv. `aspect-[21/9] w-full`): vast, zodat er niets verspringt als de foto komt. */
  className?: string;
  sizes?: string;
  /** Code uit docs/BEELDEN.md: zo weet je in de code welke foto hier hoort. */
  code: string;
  /** Het ene bewegende moment van de pagina: het beeld beweegt licht binnen zijn kader. */
  parallax?: boolean;
  priority?: boolean;
};

/**
 * De plek voor een groot beeld op een pagina. Staat er nog geen foto, dan een stil blush-vlak in
 * de goede verhouding (decoratief, geen tekst), zodat het ritme van de pagina al klopt.
 */
export function ImageSlot({
  media,
  className = '',
  sizes,
  code,
  parallax = false,
  priority = false
}: Props) {
  if (media?.image || media?.video) {
    return parallax ? <ParallaxMedia media={media} sizes={sizes} priority={priority} className={className} data-id="element-8923" data-mp="2z0bgu8ctry65" /> : <MediaView media={media} sizes={sizes} priority={priority} className={className} data-id="element-8924" data-mp="2uzsng9vaak1u" />;
  }
  return <div aria-hidden="true" data-image-slot={code} className={`bg-blush ${className}`} data-id="element-8925" data-mp="38zk64nwqwom6" />;
}